import { handleActions } from 'redux-actions';
import {LOCATION_CHANGE} from 'react-router-redux';
import http from '../shared/http';
import intl from '../shared/intl';
import _get from 'lodash/get';
import endpoints from '../../config/endpoints';

const DATA_FETCH_SUCCESS = 'user_ranks/data-fetch-success';
const DATA_FETCH_ERROR  = 'user_ranks/data-fetch-error';
const USER_IS_NOTIFIED  = 'user_ranks/user-notified';

const TOGGLE_POPUP = 'user_ranks/toggle-popup';

// initialState state
const initialState = {
	data: null,
	rankGoods: [],
	isNotificationPopupOn: false,
	error: false
};

// actions
export const actions = {
	fetchData: () => dispatch => {
		const request = http({
			url: [`${endpoints.RANKS.INFO}`, `${endpoints.RANKS.GOODS_LIST}`],
			method:'get',
			actions:[
				DATA_FETCH_SUCCESS,
				DATA_FETCH_ERROR
			]
		});

		request(dispatch)
			.then(result => {
				if (_get(result, 'payload.0.data.is_need_notify')) {
					dispatch(actions.toggleRankPopup(true));
				}
			});
	},
	toggleRankPopup: switcher => dispatch => {

		dispatch({ type: TOGGLE_POPUP, payload: Boolean(switcher) });
		if (!switcher) {
			return actions.updateIsAffiliateNotified()(dispatch);
		}
	},
	updateIsAffiliateNotified: () => dispatch =>{
		const notifiedRequest = http({
			url: `${endpoints.RANKS.NOTIFIED}`,
			method:'put',
			actions:[USER_IS_NOTIFIED]
		});
		return notifiedRequest(dispatch);
	}
};

// reducers
const reducers = Object.assign({
	[LOCATION_CHANGE]: state => initialState,
	[DATA_FETCH_SUCCESS]: (state, action) => {
		const [data, rankGoods] = action.payload.map(rk => rk.data);
		return { ...state, data, rankGoods};
	},
	[USER_IS_NOTIFIED]: (state, action) => {
		return { ...state};
	},
	[TOGGLE_POPUP]: (state, action) => ({
		...state,
		isNotificationPopupOn: action.payload
	}),
	[DATA_FETCH_ERROR]: state => {
		return { ...state, error: true };
	}
});

export default handleActions(reducers, initialState);

// selectors
export const selectors = {
	getData: state => state.ranks.data,
	getRankGoods: state => state.ranks.rankGoods,
	getRanksList: state => state.app.lists['affiliate-ranks'].map(ar => ar.text),
	getIsShowNotificationPopupOn: state => state.ranks.isNotificationPopupOn,
	getIntl: state => intl(state)
};



// WEBPACK FOOTER //
// ./frontend/cabinets/modules/ranks/index.js